import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

export default class MenuDespesa extends Component {

    botaoAtivo(path) {
        if(this.props.categoriaSelecionada === path) {
            return { backgroundColor: "#148a9c" }
        }
        else return {}
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                        <div className="col-md-12 ml-auto mr-auto">
                            {/*<a href="/"><button className="btn btn-btn-danger" >Voltar</button></a>*/}

                            <Link to={location => ({ ...location, pathname: `/sti/${this.props.unidade}/despesas/0` })} >
                                <button className="btn btn-primary" style={this.botaoAtivo(0)}>Consultoria em Tecnologia</button>
                            </Link>

                            <Link to={location => ({ ...location, pathname: `/sti/${this.props.unidade}/despesas/1` })} >
                                <button className="btn btn-primary" style={this.botaoAtivo(1)}>Serviços Técnicos Especializados</button>
                            </Link>
                            
                            <Link to={location => ({ ...location, pathname: `/sti/${this.props.unidade}/despesas/2` })} >
                                <button className="btn btn-primary" style={this.botaoAtivo(2)}>Pesquisa, Desenvolvimento e Inovação</button>
                            </Link>

                            <Link to={location => ({ ...location, pathname: `/sti/${this.props.unidade}/despesas/3` })} >
                                <button className="btn btn-primary" style={this.botaoAtivo(3)}>Metrologia</button>
                            </Link>

                            <Link to={location => ({ ...location, pathname: `/sti/${this.props.unidade}/despesas/4` })} >
                                <button className="btn btn-primary" style={this.botaoAtivo(4)}>Serviços Complementares</button>
                            </Link>

                        </div>
                    </div>
            </Fragment>
        )
    }

}